import { render, staticRenderFns } from "./ChooseTimeformat.vue?vue&type=template&id=487dad02&"
import script from "./ChooseTimeformat.vue?vue&type=script&lang=ts&"
export * from "./ChooseTimeformat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports